<template>
	<div class="myFooter">
		<div class="fTop">
			<div class="wrap">
				<div class="fl">
					<div class="ft1">
						<a href="#">
							<img src="../assets/images/msh22.png" alt="" width="140" height="45">
						</a>
						<div class="m">
							<div class="mm">
								<img src="../assets/images/img/dh.png" alt="" width="25" height="25"><span>400 700
									9161</span>
							</div>
							<div class="mm">
								<img src="../assets/images/img/yx.png" alt="" width="25"
									height="25"><span>admin@61hr.com</span>
							</div>
						</div>
					</div>
					<div class="b">
						<div class="youqinglianjie">
							<span>友情链接</span>
							<a href="https://www.61hr.com/" target="_blank" rel="noopener noreferrer">乐聘网</a>
							<a href="http://www.tianfuhr.cn/" target="_blank" rel="noopener noreferrer">天服人力</a>
							<a href="http://www.mohrss.gov.cn" target="_blank" rel="noopener noreferrer">中国人力资源和社会保障部</a>
							<a href="http://www.newjobs.com.cn" target="_blank" rel="noopener noreferrer">中国国家人才网</a>
						</div>
					</div>
				</div>
				<div class="fr">
					<div class="fr-item">
						<h4>谋生活(个人)</h4>
						<img src="../assets/grrwm.jpg" alt="">
					</div>
					<div class="fr-item">
						<h4>谋生活用工(企业)</h4>
						<img src="../assets/qyrwm.jpg" alt="">
					</div>
					<div class="fr-item">
						<h4>谋生活(微信公众号)</h4>
						<img src="../assets/mshgzh.jpg" alt="">
					</div>
				</div>
			</div>
		</div>
		<div class="fBottom">
			<div class="wrap">
				<a target="_blank" title="51la网站统计" href="https://v6.51.la/land/K3SKGxVhK3PM3OZz"><img src="https://sdk.51.la/icon/1-1.png"></a>
				<span>© 谋生活™ 上海谋事成数字科技（集团）有限公司 All Rights Reserved 丨</span>
				<!-- <img src="../assets/images/ga.png" alt="">
				<span>公安局备案号：31011502000573号 丨</span> -->
				<a href="https://beian.miit.gov.cn/"> 沪ICP备20021244号-2 </a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "myFooter",
		data() {
			return {

			}
		}
	}
</script>

<style>
	.myFooter {
		/* position: fixed;
		width: 100%;
		bottom: 0; */
		/* margin-top: 80px; */
		/* background: #6699CC; */
	}

	.myFooter .fTop {
		padding: 40px 0;
		/* background: #6699CC; */
	}

	.myFooter .fTop .wrap {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		width: 1200px;
		margin: 0 auto;
	}

	.myFooter .fTop .wrap .fl {
		display: flex;
		flex-wrap: wrap;
		width: 53%;
		position: relative;
	}

	.myFooter .fTop .wrap .fl::after {
		content: '';
		display: inline-block;
		width: 1px;
		height: 168px;
		background: linear-gradient(180deg, rgba(238, 238, 238, 0.1) 0%, #ff8500 25%, #ff8500 77%, rgba(238, 238, 238, 0.15) 100%);
		position: absolute;
		top: 0;
		right: 0;
	}

	.myFooter .fTop .wrap .fl .ft1 {
		margin: auto;
		display: flex;
	}

	.myFooter .fTop .wrap .fl .ft1 .m {
		display: flex;
		margin-left: 40px;
	}

	.myFooter .fTop .wrap .fl .ft1 .m .mm {
		width: 140px;
		height: 40px;
		line-height: 17px;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 4px 10px 0 #eff2f8;
		border-radius: 20px;
		margin-right: 20px;
	}

	.myFooter .fTop .wrap .fl .ft1 .m .mm span {
		font-size: 12px;
		color: #6d758a;
		font-weight: 400;
		margin-left: 10px;
	}
	.myFooter .fTop .wrap .fl .b{
		margin: 0 auto;
	}
	.myFooter .fTop .wrap .fl .b .youqinglianjie span {
	  line-height: 20px;
	  font-size: 14px;
	  color: #1c1c1c;
	  font-weight: 500;
	}
	.myFooter .fTop .wrap .fl .b .youqinglianjie a {
	  line-height: 20px;
	  font-size: 14px;
	  color: #6d758a;
	  font-weight: 400;
	  margin-left: 20px;
	}
	.myFooter .fTop .wrap .fr {
		width: 42%;
		display: flex;
		justify-content: center;
	}

	.myFooter .fTop .wrap .fr .fr-item {
		text-align: center;
		margin-right: 35px;
	}

	.myFooter .fTop .wrap .fr .fr-item h4 {
		margin-bottom: 20px;
		font-size: 18px;
		/* font-family: PingFangSC-Medium, PingFang SC; */
		font-weight: 400;
		/* color: #ffffff; */
		line-height: 25px;
	}

	.myFooter .fTop .wrap .fr .fr-item img {
		width: 100px;
	}

	.myFooter .fBottom {
		width: 1200px;
		border-top: 1px solid #ccc;
		margin: 0 auto;
		/* background: #6699CC; */
	}

	.myFooter .fBottom .wrap {
		padding: 18px 0;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		color: #6d758a;
		line-height: 17px;
		/* width: 1200px; */
		/* margin: 0 auto; */
		font-size: 12px;
		/* font-family: PingFangSC-Regular, PingFang SC; */
		font-weight: 400;
		/* color: #ffffff; */
	}

	.myFooter .fBottom .wrap span {
		line-height: 17px;
	}

	.myFooter .fBottom .wrap img {
		margin-right: 5px;
		width: 14px;
	}

	.myFooter .fBottom .wrap a {
		line-height: 17px;
		color: #6d758a;
	}
</style>



// WEBPACK FOOTER //
// src/components/myFooter.vue